function progress(event) {

    let self = event.target;
    let teaser = self.closest('.loading-animation--container')

    teaser.querySelector('.loading-animation').classList.add('loading');
}

function canplay(event) {

    let self = event.target;

    let teaser = self.closest('.loading-animation--container')

    teaser.querySelector('.loading-animation').classList.remove('loading');
    self.removeEventListener("progress", progress)
    self.removeEventListener("canplay", canplay)
}

document.addEventListener("DOMContentLoaded", function() {

    let videos = document.querySelectorAll('.loading-animation--container video');
    videos.forEach(video => {
        video.addEventListener("progress", progress);
        video.addEventListener("canplay", canplay);
    });
});

